var canvas, canvas2, text, newText, zoom, cWidth = 2000, cHeight = 1400,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl,
    placeholderimg1, placeholderimg2, currentSignature,
    placeholderimg4,img,
    leftMarker, rightMarker, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", canvas, boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;

var outLine,sizeBmW = 715, sizeBmH = 450,
    sizeB0W = 450, sizeB0H = 292,
    sizeB1W = 370, sizeB1H = 160;

imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');


let backImg = document.querySelector("#background_birthday");
let bg_img = new fabric.Image(backImg, {
  left: 0,   
  top: 0,
  scaleX: 1.953,
  scaleY: 1.953,
  selectable: false
});

let frameImg = document.querySelector("#design_birthday");
let simpleImage = new fabric.Image(frameImg, {
  left: 0,   
  top: 0,
  scaleX: 1.95,
  scaleY: 1.95,
  selectable: false
});
window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight
});

window['canvas2'].add(bg_img);
bg_img.sendToBack();
window['canvas2'].add(simpleImage);
simpleImage.bringToFront();
addModify(window['canvas2']);



let currentImgInstance = null; 


document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const defaultImgUrl = document.getElementById('image_preview')?.src;
    const canvas = window['canvas2'];
    const placeholder = window['placeholderimg0'];

    if (defaultImgUrl && canvas && placeholder) {
      fabric.Image.fromURL(defaultImgUrl, function (imgInstance) {
        imgInstance.set({
          left: placeholder.left,
          top: placeholder.top,
          scaleX: placeholder.width / imgInstance.width,
          scaleY: placeholder.height / imgInstance.height,
          selectable: false
        });

        imgInstance.bringToFront();
        canvas.add(imgInstance);
        canvas.renderAll();

        currentImgInstance = imgInstance;
      });
    }
  }, 300); // Wait for canvas and elements to be ready
});



window['placeholderimg1'] = new fabric.Rect({
  left: 515,
  top: 1062,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
  rx: 5,
  ry: 5
});

window['placeholderimg2'] = new fabric.Rect({
  left: 1480,
  top: 1062,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
  rx: 5,
  ry: 5
});


window['canvas2'].add(window['placeholderimg1'], window['placeholderimg2']);


document.getElementById('image_upload_first').addEventListener('change',function(e){
   canvas = window['canvas2'];
   img = window['placeholderimg1'];
   outline = window['border1'];
   available_height = img.height;
   sizeCrop = '2.12';
   reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
   readURL2(e.target);
 });

document.getElementById('image_upload_second').addEventListener('change',function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg2'];
  outline = window['border2'];
  available_height = img.height;
  sizeCrop = '2.12';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target);
});



// ---------- Curved text group helper ----------
function createCurvedTextGroup(text, opts = {}) {
  const left = opts.left ?? 1000;
  const top = opts.top ?? 395;
  const radius = opts.radius ?? 990;
  const fontSize = opts.fontSize ?? 100;
  const fontFamily = opts.fontFamily ?? 'Protest Guerrilla';
  const fill = opts.fill ?? '#000';

  const baseAngle = (typeof opts.baseAngle !== 'undefined') ? opts.baseAngle : -Math.PI / 2;

  let chars = String(text).split('');
  if (chars.length === 0) chars = [' '];

  // Step 1: measure widths of each character
  const widths = chars.map(ch => {
    const tmp = new fabric.Text(ch, { fontSize, fontFamily });
    return tmp.width || fontSize * 0.6; // fallback estimate
  });

  const totalWidth = widths.reduce((a, b) => a + b, 0);
  const totalAngle = totalWidth / radius; // full arc span
  let angle = baseAngle - totalAngle / 2; // start so text is centered

  const letters = [];

  // Step 2: place each char based on its arc length
  for (let i = 0; i < chars.length; i++) {
    const ch = chars[i];
    const charWidth = widths[i];
    const angleOffset = (charWidth / 2) / radius; // half width before center

    angle += angleOffset; // move to center of letter

    const char = new fabric.Text(ch, {
      left: Math.cos(angle) * radius,
      top: Math.sin(angle) * radius,
      originX: 'center',
      originY: 'center',
      fontSize,
      fontFamily,
      fill,
      selectable: false,
      evented: false
    });

    char.angle = angle * 180 / Math.PI + 90;
    letters.push(char);

    angle += angleOffset; // move to start for next letter
  }

  const group = new fabric.Group(letters, {
    left,
    top,
    originX: 'center',
    originY: 'center',
    lockMovementX: opts.lockMovementX ?? true,
    lockMovementY: opts.lockMovementY ?? true,
    hasControls: opts.hasControls ?? false,
    selectable: opts.selectable ?? true
  });

  group.setCoords();
  return group;
}


// ---------- Font load helper ----------
function ensureFontLoaded(fontFamily, fontSize) {
  // sanitize fontFamily (remove surrounding quotes if any)
  const f = (fontFamily || '').replace(/['"]+/g, '');
  if (document.fonts && document.fonts.load) {
    try {
      return document.fonts.load(`${fontSize}px "${f}"`);
    } catch (e) {
      return Promise.resolve();
    }
  }
  return Promise.resolve();
}

// ---------- Replace existing group on canvas ----------
function replaceCurvedGroup(group) {
  if (!window['canvas2'] || typeof window['canvas2'].add !== 'function') {
    console.error('canvas2 not found — make sure window["canvas2"] is your Fabric canvas');
    return;
  }
  if (window['text1Page']) {
    try { window['canvas2'].remove(window['text1Page']); } catch (e) {}
  }
  window['text1Page'] = group;
  window['canvas2'].add(window['text1Page']);
  window['canvas2'].renderAll();
}

// ---------- Fit algorithm (tries fontSize -> then arc -> then radius) ----------
function fitCurvedTextToWidth(newText, maxWidth = 1450, opts = {}) {
  const left = opts.left ?? 1000;
  const top = opts.top ?? 395;
  const startFontSize = opts.fontSize ?? 100;
  const minFontSize = opts.minFontSize ?? 65;
  const startTotalAngleDeg = (typeof opts.totalAngleDeg !== 'undefined') ? opts.totalAngleDeg : 200;
  const minTotalAngleDeg = opts.minTotalAngleDeg ?? 50;
  const startRadius = opts.radius ?? 990;
  const fontFamily = (opts.fontFamily || window['currentFont'] || 'Protest Guerrilla').replace(/['"]+/g, '');
  const fill = opts.fill ?? '#000';

  // load the font once (best-effort) then do measurements synchronously
  return ensureFontLoaded(fontFamily, startFontSize).then(() => {
    let fontSize = startFontSize;
    let totalAngleDeg = startTotalAngleDeg;
    let radius = startRadius;

    let group = createCurvedTextGroup(newText, {
      left, top, radius, fontSize, fontFamily, fill, totalAngleDeg
    });

    // 1) reduce font size until fits
    while (group.width > maxWidth && fontSize > minFontSize) {
      fontSize -= 1;
      group = createCurvedTextGroup(newText, {
        left, top, radius, fontSize, fontFamily, fill, totalAngleDeg
      });
    }

    // 2) if still too wide, tighten the arc (reduce totalAngleDeg)
    while (group.width > maxWidth && totalAngleDeg > minTotalAngleDeg) {
      totalAngleDeg -= 5;
      group = createCurvedTextGroup(newText, {
        left, top, radius, fontSize, fontFamily, fill, totalAngleDeg
      });
    }

    // 3) final fallback: decrease radius (makes arc tighter)
    while (group.width > maxWidth && radius > 50) {
      radius -= 10;
      group = createCurvedTextGroup(newText, {
        left, top, radius, fontSize, fontFamily, fill, totalAngleDeg
      });
    }

    // finished — replace on canvas
    replaceCurvedGroup(group);
    return group;
  }).catch(err => {
    // If font loading failed, still attempt to create the group
    const group = createCurvedTextGroup(newText, {
      left, top, radius: startRadius, fontSize: startFontSize, fontFamily, fill, totalAngleDeg: startTotalAngleDeg
    });
    replaceCurvedGroup(group);
    return group;
  });
}

// ---------- Initialization & event wiring ----------
if (!window['canvas2'] || typeof window['canvas2'].add !== 'function') {
  console.error('canvas2 not found — make sure window["canvas2"] is your Fabric canvas');
} else {
  // default font (no surrounding quotes)
  window['currentFont'] = 'Protest Guerrilla';

  // initial draw (replace your old straight text)
  fitCurvedTextToWidth('Certificate of Appreciation on Retirement', 1450, {
    left: 1000,
    top: 395,
    radius: 990,
    fontSize: 100,
    charSpacing: 1500,
    totalAngleDeg: 200,
    fontFamily: 'Protest Guerrilla',
    fill: '#000'
  });

  // If you have an input with id="text_1", this updates live
  const txtInput = document.getElementById('text_1');
  if (txtInput) {
    // set initial input value (optional)
    if (!txtInput.value) txtInput.value = 'Certificate of Appreciation on Retirement';

    // clear default on focus (same behavior you had)
    txtInput.addEventListener('focus', function () {
      if (txtInput.value === 'Certificate of Appreciation on Retirement') {
        txtInput.value = '';
        fitCurvedTextToWidth('', 1450, { left: 1000, top: 395 });
      }
    });

    // live update while typing
    txtInput.addEventListener('input', function (e) {
      const newVal = e.target.value;
      fitCurvedTextToWidth(newVal || '', 1450, {
        left: 1000,
        top: 395,
        radius: 990,
        fontSize: 100,
        charSpacing: 1500,
        totalAngleDeg: 200,
        fontFamily: 'Protest Guerrilla',
        fill: '#000'
      }).then(g => { try { g.bringToFront(); } catch (e) {} });
    });
  }

  // font dropdown handler (expects .choose_font to contain font names; removes quotes if present)
  jQuery('.choose_font').on('change', function () {
    let newFont = (jQuery(this).val() || '').replace(/['"]+/g, '');
    if (!newFont) return;
    window['currentFont'] = newFont;

    // update the dropdown display to keep consistency (optional)
    jQuery(this).val("'" + newFont + "'").trigger('change.select2');

    // re-render with current input or default text
    const currentText = (txtInput && txtInput.value) ? txtInput.value : 'Certificate of Appreciation on Retirement';
    fitCurvedTextToWidth(currentText, 1450, {
      left: 1000,
      top: 395,
      radius: 990,
      fontSize: 100,
      charSpacing: 1500,
      totalAngleDeg: 200,
      fontFamily: 'Protest Guerrilla',
      fill: '#000'
    });
  });
}



window['text2Page'] = new fabric.Text('This certificate is proudly presented to',{
  left: 1000,
  top: 470,
  fontSize: 50,
  fontFamily: 'Arial',
  textAlign: 'center',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

window['canvas2'].add(window['text2Page']);

// Clear text on input focus if default
document.getElementById('text_2').addEventListener('focus', function () {
  if (window['text2Page'].text === 'This certificate is proudly presented to') {
    window['text2Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth2(textObj, maxWidth) {
  let fontSize = 60; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_2').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text2Page'].set('text', newText);
  fitTextToWidth2(window['text2Page'], 750);
  window['text2Page'].bringToFront();
  window['canvas2'].renderAll();
});




window['text3Page'] = new fabric.Text('check',{
  left: 1000,
  top: 580,
  fontSize: 100,
  fontFamily: 'Comic Sans MS',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

var fontName = window['text3Page'].fontFamily;
jQuery('.choose_font').val("'" + fontName + "'").trigger('change');

// Add to canvas
window['canvas2'].add(window['text3Page']);

// Clear text on input focus if default
document.getElementById('text_3').addEventListener('focus', function () {
  if (window['text3Page'].text === 'Ella Prejzner') {
    window['text3Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth(textObj, maxWidth) {
  let fontSize = 100; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_3').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text3Page'].set('text', newText);
  fitTextToWidth(window['text3Page'], 1000);
  window['text3Page'].bringToFront();
  window['canvas2'].renderAll();
});



window['text0Page'] = new fabric.Text('For',{
  left: 1000,
  top: 685,
  fontSize: 55,
  fontFamily: 'Arial',
  textAlign: 'center',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

window['canvas2'].add(window['text0Page']);

// Clear text on input focus if default
document.getElementById('text_0').addEventListener('focus', function () {
  if (window['text0Page'].text === 'For') {
    window['text0Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth0(textObj, maxWidth) {
  let fontSize = 55; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_0').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text0Page'].set('text', newText);
  fitTextToWidth0(window['text0Page'], 500);
  window['text0Page'].bringToFront();
  window['canvas2'].renderAll();
});



var maxWidth = 1200;
var maxHeight = 170;

var para = "In recognition of 30 years of dedicated service\nand valuable contribution to Evergreen Industries Pvt. Ltd.\nWe extend our gratitude and best wishes for a happy and fulfilling retirement.\nAwarded on this 1st day of October, 2025." ;

window['text4Page'] = new fabric.Text(para,{
  left: 985,
  top: 815,
  width: 1200,
  fontSize: 37,
  lineHeight: 1,
  fontFamily: 'Arial',
  textAlign: 'center',
  isWrapping: true,
  fill: '#000'
});


window['canvas2'].add(window['text4Page']);


var minFontSize = 10;
var maxFontSize = 45;

// Clear text on input focus if default
document.getElementById('text_4').addEventListener('focus', function () {
  if (window['text4Page'].text === 'In recognition of 30 years of dedicated service\nand valuable contribution to Evergreen Industries Pvt. Ltd.\nWe extend our gratitude and best wishes for a happy and fulfilling retirement.\nAwarded on this 1st day of October, 2025.') {
    window['text4Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


// Helper: Adjust font size to fit both width and height
function autoFitText2(textbox, maxW, maxH) {
  let fontSize = maxFontSize;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_4').addEventListener('input', function (e) {
  const input = e.target.value;
  window['text4Page'].set({
    text: input
  });
  fitTextToBox(window['text4Page'], maxWidth, maxHeight);
});

function fitTextToBox(textObj, maxWidth, maxHeight) {
  let fontSize = maxFontSize;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth || textObj.height > maxHeight;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}


window['text5Page'] = new fabric.Text('Hr Signature',{
  left: 506,
  top: 1195,
  fontSize: 40,
  fontFamily: 'Arial',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});


// Add to canvas
window['canvas2'].add(window['text5Page']);

// Clear text on input focus if default
document.getElementById('text_5').addEventListener('focus', function () {
  if (window['text5Page'].text === 'Hr Signature') {
    window['text5Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth5(textObj, maxWidth) {
  let fontSize = 40; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_5').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text5Page'].set('text', newText);
  fitTextToWidth5(window['text5Page'], 410);
  window['text5Page'].bringToFront();
  window['canvas2'].renderAll();
});



window['text6Page'] = new fabric.Text('CEO Signature',{
  left: 1475,
  top: 1193,
  fontSize: 40,
  fontFamily: 'Arial',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});


// Add to canvas
window['canvas2'].add(window['text6Page']);

// Clear text on input focus if default
document.getElementById('text_6').addEventListener('focus', function () {
  if (window['text6Page'].text === 'CEO Signature') {
    window['text6Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth6(textObj, maxWidth) {
  let fontSize = 40; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_6').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text6Page'].set('text', newText);
  fitTextToWidth6(window['text6Page'], 410);
  window['text6Page'].bringToFront();
  window['canvas2'].renderAll();
});


window['text7Page'] = new fabric.Text('APPROVED',{
  left: 995,
  top: 1067,
  fontSize: 25,
  fontFamily: 'Arial',
  fill: '#725a1b',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});


// Add to canvas
window['canvas2'].add(window['text7Page']);

// Clear text on input focus if default
document.getElementById('text_7').addEventListener('focus', function () {
  if (window['text7Page'].text === 'APPROVED') {
    window['text7Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth7(textObj, maxWidth) {
  let fontSize = 25;  
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_7').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text7Page'].set('text', newText);
  fitTextToWidth7(window['text7Page'], 150);
  window['text7Page'].bringToFront();
  window['canvas2'].renderAll();
});


function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

  jQuery(window).on('load',function(){
    canvasBlock(canvas);
  });

  jQuery(window).on('resize',function(){
    canvasBlock(canvas);
  });
}

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler() {
  var activeOb = window['canvas2'].getActiveObject();
  if (activeOb) {
    window['canvas2'].remove(activeOb);
    window['canvas2'].renderAll();
  }
}


initCropper();

function readURL2(input){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  if(cropper == ""){
  }else {
    cropper.destroy();
  }
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      jQuery('#blah').attr('src', e.target.result);
      reCroper.attr('data-img',e.target.result);
    };
    reader.readAsDataURL(input.files[0]);
    setTimeout(initCropper, 2500);
  }
}

function addImage(e,placeholderimg,canvas){
  var file = e.target.files[0];
  var reader = new FileReader();
  reader.onload = function(event){
    var imgObj = new Image();
    imgObj.src = event.target.result;
    imgObj.onload = function(){
      var img = new fabric.Image(imgObj);
      img.set({
        left: placeholderimg.left,
        top: placeholderimg.top,
        selectable:true,
        scaleX: placeholderimg.width / img.width,
        scaleY: placeholderimg.height / img.height,
        clipPath: new fabric.Rect({
          width: img.width,
          height: img.height,
          rx: 20, // Apply border radius from placeholder
          ry: 20
        })
      });
    };
  };
  reader.readAsDataURL(file);
}

let currentUploadedImages = {
  logo: null,
  first: null,
  second: null
};
window['placeholderimg1'].objKey = "first";
window['placeholderimg2'].objKey = "second";

function addCroppedImg(imgurl){
  canvas.remove(img).renderAll();
  // Remove old uploaded image for this placeholder if exists
  if(currentUploadedImages[img.objKey]) {
    canvas.remove(currentUploadedImages[img.objKey]);
  }

  fabric.Image.fromURL(imgurl, function(newImg){
    const scale = newImg.width / img.width;
    newImg.set({
      left: img.left,
      top: img.top,
      originX: 'center',
      originY: 'center'
    });
    newImg.scaleToHeight(available_height);

    // Clip with rounded corners
    const clipPath = new fabric.Rect({
      width: newImg.width,
      height: newImg.height,
      rx: img.rx * scale,
      ry: img.ry * scale,
      left: 0,
      top: 0,
      originX: 'center',
      originY: 'center',
      fill: 'transparent'
    });
    newImg.clipPath = clipPath;

    // Add new image
    canvas.add(newImg);
    canvas.bringToFront(outline);

    // Save reference (important!)
    currentUploadedImages[img.objKey] = newImg;

    canvas.renderAll();
  });
}

function initCropper(){
  var image = document.getElementById('blah');
  cropper = new Cropper(image, {
    viewMode: 1,
    dragMode: 'move',
    aspectRatio: sizeCrop,
    restore: false,
    guides: false,
    center: true,
    highlight: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    data:{}
  });
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').addClass('hidden');
  loader.addClass('hidden');
}

document.getElementById('crop_button').addEventListener('click', function(){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  var imgurl =  cropper.getCroppedCanvas().toDataURL();
  addCroppedImg(imgurl);
  setTimeout(function(){
    reCroper.parent().removeClass('hidden');
    jQuery('.popupImg').hide();
    loader.addClass('hidden');
    jQuery('#tadaWidget').removeClass('hidden');
  },500);
});

document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});

document.getElementById('reset_button').addEventListener('click', function(){
  cropper.reset();
});

document.getElementById('cancelCropper').addEventListener('click', function(){
  jQuery('.popupImg').hide();
  jQuery('#tadaWidget').removeClass('hidden');
});

jQuery(document).on('click','.btnReCrop', function(){
  loader.removeClass('hidden');
  imgurl = jQuery(this).attr('data-img');
  sizeCrop = jQuery(this).attr('data-ratio');
  img = window[jQuery(this).attr('data-obj')];
  canvas = window[jQuery(this).attr('data-canvas')];
  available_height = jQuery(this).attr('data-height');
  console.log(canvas);
  jQuery('#tadaWidget').addClass('hidden');
  setTimeout(function(){
    cropper.destroy();
    jQuery('#blah').attr('src',imgurl);
    initCropper();
    jQuery('.popupImg').show();
    loader.addClass('hidden');
  },150);
});




// keep signature reference globally
var currentSignature = null;


$(document).ready(function() {
  // Signature pad canvas
  var managersignatureCanvas = new fabric.Canvas('managersignatureCanvas', {
    isDrawingMode: true
  });
  managersignatureCanvas.freeDrawingBrush.color = "black";
  managersignatureCanvas.freeDrawingBrush.width = 2;

  // On submit
  $("#submitDrawing").on("click", function(e) {
    e.preventDefault();

    if (managersignatureCanvas.isEmpty()) {
      alert("Please draw your signature before submitting.");
      return;
    }

    var signatureData = managersignatureCanvas.toDataURL("image/png");

    fabric.Image.fromURL(signatureData, function(managsign) {
      if (currentSignature) {
        window['canvas2'].remove(currentSignature);
      }

      managsign.set({
        left: 515,
        top: 1062,
        scaleX: 1.2,
        scaleY: 1.2,
        hasControls: true,
        hasBorders: true,
        selectable: true
      });

      window['canvas2'].add(managsign).setActiveObject(managsign);
      currentSignature = managsign; // ✅ global reference
      window['canvas2'].renderAll();

      // Once user deselects, make it unselectable
      window['canvas2'].on('selection:cleared', function() {
        if (currentSignature) {
          currentSignature.selectable = true;
          currentSignature.hasControls = true;
          currentSignature.hasBorders = true;
          window['canvas2'].renderAll();
        }
      });
      
    });

    managersignatureCanvas.clear();
  });
});




$(document).ready(function () {
  // Hide both by default, then show upload section
  $(".manager_signature_image, .manually_manager_signature").hide();
  $(".manager_signature_image").show();

  $("#manager_signature").on("change", function () {
    var value = $(this).val();

    if (value === "Upload Image 1") {
      // Show upload, hide manual
      $(".manager_signature_image").show();
      $(".manually_manager_signature").hide();

      // Show placeholders
      if (window['placeholderimg1']) window['placeholderimg1'].set({ visible: true });

      if (typeof currentUploadedImages.first !== "undefined" && currentUploadedImages.first) currentUploadedImages.first.set({ visible: true });


      // Hide signature
      if (typeof currentSignature !== "undefined" && currentSignature) {
        currentSignature.set({ visible: false });
      }

    } else if (value === "Signature Manually 1") {
      // Show manual, hide upload
      $(".manually_manager_signature").show();
      $(".manager_signature_image").hide();

      // Hide placeholders
      if (window['placeholderimg1']) window['placeholderimg1'].set({ visible: false });

      if (typeof currentUploadedImages.first !== "undefined" && currentUploadedImages.first) currentUploadedImages.first.set({ visible: false });


      // Show signature
      if (typeof currentSignature !== "undefined" && currentSignature) {
        currentSignature.set({ visible: true });
      }
    }

    window['canvas2'].renderAll();
  });
});





// keep signature reference globally
var CeoSignature = null;


$(document).ready(function() {
  // Signature pad canvas
  var ceosignatureCanvas = new fabric.Canvas('ceosignatureCanvas', {
    isDrawingMode: true
  });
  ceosignatureCanvas.freeDrawingBrush.color = "black";
  ceosignatureCanvas.freeDrawingBrush.width = 2;

  // On submit
  $("#submitDrawingceo").on("click", function(e) {
    e.preventDefault();

    if (ceosignatureCanvas.isEmpty()) {
      alert("Please draw your signature before submitting.");
      return;
    }

    var signatureData2 = ceosignatureCanvas.toDataURL("image/png");

    fabric.Image.fromURL(signatureData2, function(managsign2) {
      if (CeoSignature) {
        window['canvas2'].remove(CeoSignature);
      }

      managsign2.set({
        left: 1480,
        top: 1062,
        scaleX: 1.2,
        scaleY: 1.2,
        hasControls: true,
        hasBorders: true,
        selectable: true
      });

      window['canvas2'].add(managsign2).setActiveObject(managsign2);
      CeoSignature = managsign2; // ✅ global reference
      window['canvas2'].renderAll();

      // Once user deselects, make it unselectable
      window['canvas2'].on('selection:cleared', function() {
        if (CeoSignature) {
          CeoSignature.selectable = true;
          CeoSignature.hasControls = true;
          CeoSignature.hasBorders = true;
          window['canvas2'].renderAll();
        }
      });
      
    });

    ceosignatureCanvas.clear();
  });
});




$(document).ready(function () {
  // Hide both by default, then show upload section
  $(".ceo_signature_image, .manually_ceo_signature").hide();
  $(".ceo_signature_image").show();

  $("#ceo_signature").on("change", function () {
    var value = $(this).val();

    if (value === "Upload Image 2") {
      // Show upload, hide manual
      $(".ceo_signature_image").show();
      $(".manually_ceo_signature").hide();

      // Show placeholders
      if (window['placeholderimg2']) window['placeholderimg2'].set({ visible: true });

      if (typeof currentUploadedImages.second !== "undefined" && currentUploadedImages.second) currentUploadedImages.second.set({ visible: true });


      // Hide signature
      if (typeof CeoSignature !== "undefined" && CeoSignature) {
        CeoSignature.set({ visible: false });
      }

    } else if (value === "Signature Manually 2") {
      // Show manual, hide upload
      $(".manually_ceo_signature").show();
      $(".ceo_signature_image").hide();

      // Hide placeholders
      if (window['placeholderimg2']) window['placeholderimg2'].set({ visible: false });

      if (typeof currentUploadedImages.second !== "undefined" && currentUploadedImages.second) currentUploadedImages.second.set({ visible: false });


      // Show signature
      if (typeof CeoSignature !== "undefined" && CeoSignature) {
        CeoSignature.set({ visible: true });
      }
    }

    window['canvas2'].renderAll();
  });
});





jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

jQuery(document).on('change','.fontFamily',function(){
  var fontID = jQuery(this).attr('data-canvas'),
      textOb = jQuery(this).attr('data-obj');
  canvas = window[fontID];
  activeOb = window[textOb];
  activeOb.set({ fontFamily: this.value });
  fontFamily = jQuery(this).val();
  canvas.renderAll();
  updateFont(window['text3Page'],fontFamily);
  fitTextToWidth(window['text3Page'], 1000);
});



function updateFont(activeOb,family){
  if(activeOb){
    if(family == ''){
      family = activeOb.fontFamily;
    }
    sCAle = activeOb.scaleX;
    activeOb.set('fontFamily',family);
    activeOb.scaleX = .5;
    activeOb.setCoords();
    canvas.renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    canvas.renderAll();
  }
}


jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});




jQuery(window).on('load',function(){
  canvasBlock(canvas2);
  window['text3Page'].set('text','Ella Prejzner');
  window['canvas2'].renderAll();
  // loadFirstImg();
});


function getCookie(name){
  let nameEQ = name + "=";
  let cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++){
    let cookie = cookies[i].trim();
    if(cookie.indexOf(nameEQ) === 0){
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

window.addEventListener("load", function(){
  if(getCookie("firstVisit")){
    console.log("✅ Cookie exists:", getCookie("firstVisit"));
  } else{
    console.log("❌ Cookie does not exist!");
    document.cookie = "firstVisit=textresizing; expires=" + new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString() + "; path=/;";
    location.reload();
  }
});


async function handleUpload(fileInputs,timeID){
  const temp_images = [];
  
  for (let input of fileInputs){
    const file = input.files[0]; // Only first file per input
    const croppedURL = jQuery(input).attr('data-cropped');
    if(croppedURL != ''){
      temp_images.push(croppedURL);
    }
    if(file){
      const base64 = await toBase64(file); // ✅ now safely inside async
      temp_images.push(base64);
    }
  }
  if(temp_images.length === 0){
    alert("Please select at least one image.");
    return;
  }
  const payload = {
    timeId: timeID,
    temp_images: temp_images
  };
  console.log(payload);
  try {
    const response = await fetch('//technology-architects.com/tasweer-modules/upload_client_img.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    
    const result = await response.json();
    console.log("Upload result:", result);
    var int = 1, wall = 1, upCrop;
    result.uploaded_images.forEach(img => {
      if(jQuery('#image'+int).length < 1){
        if (int % 2 === 0) {
          upCrop = 'User Uploaded ';
        }else{
          upCrop = 'Cropped ';
        }
        jQuery('#preview').append('<input type="hidden" id="image'+int+'" name="properties['+ upCrop + wall+']">');
        if(upCrop == 'User Uploaded '){
          wall += 1;
        }
      }
      if (img.status === "success") {
        jQuery('#image'+int).val(img.image_url);
        int += 1;
      } else {
        console.warn("Upload failed:", img.error);
      }
    });
    jQuery('.product-form__buttons .product-form__submit').trigger('click');
    loader.addClass('hidden');
  } catch (error) {
    console.error("Upload error:", error);
    alert("Upload failed.");
  }
}

// ✅ Convert a file to base64 string
function toBase64(file){
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}


/* fetch Call */
var size,thumbnail;
var loadedObject,certificateTitle,presentedText,enterName,chooseFont,forText,enterDetails,awardText,mngSignature,signatureText1,ceoSignature,signatureText2,otherNames,additionalInfo,frameColor,wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 350;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    // hideExtras(canvas);
    window['canvas2'] = canvas.toDataURL('image/png');
    certificateTitle = jQuery('.certificate_title input').val();
    presentedText = jQuery('.presented_text input').val();
    enterName = jQuery('.enter_name input').val();
    chooseFont = jQuery('.choose_font option:selected').val();
    forText = jQuery('.for_text input').val();
    enterDetails = jQuery('.enter_details textarea').val();
    awardText = jQuery('.award_text textarea').val();
    mngSignature = jQuery('#manager_signature option:selected').val();
    signatureText1 = jQuery('.signature_text1 input').val();
    ceoSignature = jQuery('#ceo_signature option:selected').val();
    signatureText2 = jQuery('.signature_text2 input').val();
    otherNames = jQuery('.another_name textarea').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    frameColor = jQuery('.frameColorBox').val();
    // showExtras(canvas);
    canvasBlock(canvas);
    console.log(window['canvas2']);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#certificateTitle').val(certificateTitle);
      jQuery('#presentedText').val(presentedText);
      jQuery('#enterName').val(enterName);
      jQuery('#chooseFont').val(chooseFont);
      jQuery('#forText').val(forText);
      jQuery('#enterDetails').val(enterDetails);
      jQuery('#awardText').val(awardText);
      jQuery('#mngSignature').val(mngSignature);
      jQuery('#signatureText1').val(signatureText1);
      jQuery('#ceoSignature').val(ceoSignature);
      jQuery('#signatureText2').val(signatureText2);
      jQuery('#otherNames').val(otherNames);
      jQuery('#addInfo').val(additionalInfo);
      jQuery('#selected_frameColor').val(frameColor);
      //console.log('Server response:', data);
      const fileInputs = document.querySelectorAll('.upload_image input[type="file"]');
      handleUpload(fileInputs,previewId);
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});



function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}